import { computed, defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { formatDate } from "../../../../../common/vue-helpers/modifiers/value-modifier";
import config from "../../../../../common/config";
import { NavigationService } from "../../../../../services/navigation.service";
import { TaskService } from "../../../../../services/task.service";
import { ReportService } from "../../../../../services/report-service";
import { FrequencyStatuses } from "../../../../../enums/FrequencyStatusesEnum";
import { getHospiceRedirectionUrl } from "../../../../../common/get-hospice-redirection-url";
import { AnalyticsCategory } from "../../../../../services/analytics.service";

import EmptyTextHandler from "../../../../../resources-vue/vue-custom-elements/EmptyTextHandler/EmptyTextHandler.vue";
import FrequencyWatchHosForm from "../FrequencyWatchHosForm/FrequencyWatchHosForm.vue";
import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import ScheduleVisit from "../../../../../resources-vue/vue-dialogs/ScheduleVisit/ScheduleVisit.vue";
import Pagination from "../../../../../resources-vue/vue-elements/Pagination/Pagination.vue";
import SortableTh from "../../../../../resources-vue/vue-custom-elements/SortableTh/SortableTh.vue";
import ErrorMessageHandler from "../../../../../resources-vue/vue-custom-elements/ErrorMessageHandler/ErrorMessageHandler.vue";

export default defineComponent({
    components: {
        EmptyTextHandler,
        FrequencyWatchHosForm,
        FormSection,
        Pagination,
        SortableTh,
        ErrorMessageHandler
    },
    props: {
        columns: {
            type: Number
        },
        frequencyItem: {
            type: Object
        },
        frequencyDiscipline: {
            type: Object
        },
        application: {
            type: Number
        },
        selectedAgency: {
            type: String
        },
        selectedBranches: {
            type: String
        }
    },
    data(vm) {
        return {
            _reportsService: null as ReportService,
            _taskService: null as TaskService,
            isEditRequested: false,
            isEditInProgress: false as boolean,
            _navigationService: null as NavigationService,
            isRowExpanded: false as boolean,
            isLoading: false as boolean,
            page: [] as any,
            loadingCount: 5,
            dialogRef: null,
            isWeeklyRowExpanded: false as boolean,
            isError: false as boolean,
            freqyencyWatchWeeklyPagination: null,
            pageSize: 10,
            formatDate
        };
    },
    provide() {
        return {
            dialogRef: computed(() => this.dialogRef)
        };
    },

    computed: {
        hasData() {
            return this.page.length > 0;
        }
    },

    created() {
        this._navigationService = Container.instance.get(NavigationService);
        this._taskService = Container.instance.get(TaskService);
        this._reportsService = Container.instance.get(ReportService);
    },

    methods: {
        getFrequencyStatusName(value: number) {
            return Array.from(FrequencyStatuses.enumWithDescriptions.values()).filter(
                (status) => status.value === value
            )[0].name;
        },
        messageUser() {
            this.isEditRequested = true;
        },

        cancel() {
            this.isEditRequested = false;
        },

        async handlePatientNameClick(resource: any) {
            let redirectResponse;
            let action = "";

            redirectResponse = {
                redirectUrl: `${getHospiceRedirectionUrl(this.selectedAgency)}/patients/patient-chart/${resource.PatientId}?accountId=${this.selectedAgency}`,
                isSuccessful: true
            };
            action = "AxxessHospice";

            this._navigationService.redirect(redirectResponse, {
                category: AnalyticsCategory.CentralCalendarNavigation,
                action
            });
        },

        getDisciplineName(discipline: number) {
            const disciplineData = this.frequencyDiscipline.filter((item: any) => item.value == discipline);
            return disciplineData[0].name;
        },
        // uncomment this once further feature is implemented
        // async expandRow(frequencyItem?: any) {
        //     this.isRowExpanded = !this.isRowExpanded;
        //     if (this.isRowExpanded) {
        //         await this.getWeeklyFrequencyWatch(frequencyItem);
        //     }
        // },

        // async getWeeklyFrequencyWatch(frequencyItem: any) {
        //     try {
        //         this.isLoading = true;
        //         this.isError = false;
        //         let payload: IFrequencyWatchWeeklyRequest = {
        //             Application: this.application,
        //             AccountId: this.selectedAgencies,
        //             UserId: "",
        //             LocationIds: [this.selectedBranches],
        //             StartDate: frequencyItem.StartDate,
        //             EndDate: frequencyItem.EndDate,
        //             Page: 1,
        //             PageLength: 10,
        //             TeamList: [],
        //             LineOfService: 1,
        //             IsUnder: null,
        //             Disciplines: [frequencyItem.Discipline],
        //             Tags: [],
        //             SortBy: "patientLastName",
        //             Order: "asc",
        //             FrequencyStatuses: [],
        //             PatientId: frequencyItem.PatientId
        //         };
        //         let response = (await this._reportsService.getFrequencyWatchWeekly(payload)) as any;
        //         this.page = response;
        //     } catch (e) {
        //         this.isError = true;
        //         return PAGE_FAIL_RESPONSE;
        //     } finally {
        //         this.isLoading = false;
        //     }
        // },

        expandWeeklyRow(frequencyItem?: any) {
            this.isWeeklyRowExpanded = !this.isWeeklyRowExpanded;
            if (this.isWeeklyRowExpanded) {
                const payload = {
                    start: frequencyItem.StartDate,
                    end: frequencyItem.EndDate,
                    patientIds: [frequencyItem.PatientId]
                };
                const tasks = this._taskService.getTasksByPatients(payload);
            }
        },

        openAddTaskForm(patient: any) {
            const visitDetails = {
                Application: this.application,
                AgencyId: this.selectedAgency,
                LocationIds: [this.selectedBranches],
                FirstName: patient.PatientName.split(",")[0],
                LastName: patient.PatientName.split(",")[1],
                AgencyName: "",
                Id: patient.PatientId
            };

            this.dialogRef = this.$dialog.open(ScheduleVisit, {
                props: {
                    modal: true,
                    showHeader: false
                },
                data: {
                    visitDetails
                }
            });
        }
    }
});
